import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { childrenExist, createShorthandFactory, commonPropTypes, rtlTextContainer } from '../../lib';
import createComponent from '../../lib/createComponent';
import { withSafeTypeForAs } from '../../types';
var Box = createComponent({
  displayName: 'Box',
  className: 'ui-box',
  propTypes: Object.assign({}, commonPropTypes.createCommon()),
  render: function render(config, props) {
    var ElementType = config.ElementType,
        classes = config.classes,
        unhandledProps = config.unhandledProps;
    var children = props.children,
        content = props.content;
    return React.createElement(ElementType, _extends({}, rtlTextContainer.getAttributes({
      forElements: [children, content]
    }), unhandledProps, {
      className: classes.root
    }), childrenExist(children) ? children : content);
  }
});
Box.create = createShorthandFactory({
  Component: Box
});
/**
 * A Box is a basic component, commonly used for slots in other Stardust components.
 * By default it just renders a `div`.
 */

export default withSafeTypeForAs(Box);